export default __webpack_public_path__ + "static/Scott.Turlington_social-7b9ecf31e93ea9db3ce8e5025eff6ea3.jpg";